import { render, staticRenderFns } from "./IpetForm.vue?vue&type=template&id=94539134&scoped=true&"
import script from "./IpetForm.vue?vue&type=script&lang=js&"
export * from "./IpetForm.vue?vue&type=script&lang=js&"
import style0 from "./IpetForm.vue?vue&type=style&index=0&id=94539134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94539134",
  null
  
)

export default component.exports